import { FC } from 'react';

import { CheckedIcon, IndeterminateIcon } from '@/components/ui/Icons/Icons';

import * as S from './Checkbox.styles';

interface CheckboxProps {
  isChecked: boolean;
  isIndeterminate?: boolean;
  isPrimary?: boolean;
  isSecondary?: boolean;
  onChange?: () => void;
  readOnly?: boolean;
}

export const Checkbox: FC<CheckboxProps> = ({
  onChange,
  isChecked,
  isIndeterminate,
  isSecondary,
  readOnly
}) => {
  return (
    <S.CheckboxLabel onClick={readOnly ? undefined : e => e.stopPropagation()}>
      <S.CheckboxInput
        data-testid="checkbox"
        type="checkbox"
        readOnly={!onChange}
        checked={isChecked}
        onChange={onChange}
      />

      <S.CheckboxIndicator
        $isChecked={isChecked}
        $isIndeterminate={isIndeterminate}
        $isSecondary={isSecondary}
      >
        {isChecked && <CheckedIcon />}
        {isIndeterminate && <IndeterminateIcon />}
      </S.CheckboxIndicator>
    </S.CheckboxLabel>
  );
};
